export default {
  "translation": {
    "card_application": "Kart Başvurusu",
    "card_application_des": "Bir Sonic kartı alın ve bunu dünya genelinde 44M+ Visa onaylı satıcıda kullanın.",
    "spend_your_crypto_like_fiat": "Kripto paralarınızı fiat gibi harcayın",
    "use_globally_across_borders": "Dünya genelinde, sınırlar ötesinde kullanın",
    "ultra_low_trans_costs": "Ultra düşük işlem maliyetleri",
    "seamless_and_secure": "Kesintisiz ve Güvenli",
    "two_factor_verification": "İki Faktörlü Doğrulama",
    "two_factor_verification_des": "E-posta, telefon, biyometrik veriler ve/veya kimlik doğrulama uygulaması kullanarak güvenli bir şekilde giriş yapın",
    "safety_pin": "Güvenlik PIN'i",
    "safety_pin_des": "Bir PIN oluşturarak özel bilgilere erişimi kısıtlayın",
    "trans_3ds_verification": "3DS Doğrulama",
    "trans_3ds_verification_des": "İşlemler işlenmeden önce satın alımları yetkilendirin",
    "additional_security": "Ek Güvenlik",
    "additional_security_des": "Uygulama üzerinden kart limitleri ve diğer güvenlik özelliklerini kolayca ayarlayın",
    "get_your_redotpay_card_in_steps": "Sonic kartınızı 3 basit adımda alın.",
    "get_your_redotpay_card_subtitle": "Kriptonuzu itibari para gibi harcayın: Dünya genelinde 44M+ Visa destekli satıcıda kabul edilir.",
    "continue_key": "Devam",
    "bind_your_mobile_number": "Mobil Numaranızı Bağlayın",
    "complete_identity_verification": "Kimlik doğrulamasını tamamlayın",
    "apply_a_virtual_or_physical_card": "Sanal veya fiziksel kart için başvurun",
    "transactions": "İşlemler",
    "need_mobile_bind_confirm": "Önce mobil bağlamak gerekiyor",
    "info": "Bilgi",
    "card_trans_status_refund_pending": "İade Bekliyor",
    "card_trans_status_refund_success": "İade Başarılı",
    "card_trans_status_refund_fail": "İade Başarısız",
    "card_trans_status_refund_wait": "İade Bekliyor",
    "card_trans_status_pending": "Yetkilendirildi",
    "card_trans_status_cleared": "Temizlendi",
    "card_trans_status_declined": "Reddedildi",
    "card_trans_status_canceled": "İptal Edildi",
    "card_trans_status_refund": "İade",
    "card_trans_status_refund_cancel": "İade İptali",
    "refund": "İade",
    "transaction_list": "İşlem Listesi",
    "more": "Daha Fazla",
    "top_questions": "En Çok Sorulan Sorular",
    "faq": "SSS",
    "self_service": "Kendi Kendine Hizmet",
    "support_center": "Destek Merkezi",
    "hello": "Merhaba",
    "updated_on": "Güncellendi",
    "chat_with_us": "Bizimle Sohbet Edin",
    "warning": "Uyarı",
    "security_option_change_alert_prompt": "Google Authenticator/mobil/e-posta/PIN'i kaldırma/değiştirme işlemi sonrası, çekim ve iç transfer devre dışı bırakılacak ve kart işlemleri güvenlik nedeniyle sonraki 24 saat içinde işlem başına $1000 ile sınırlı olacaktır.",
    "cancel": "İptal",
    "ok": "Tamam",
    "account_deletion_regret_promp": "Hesap silme işlemi size 15 günlük bir pişmanlık süresi tanır. Silme başvurusundan sonraki 15 gün içinde tekrar giriş yaparsanız, başvurunuz iptal edilecek ve hesabınızı normal şekilde kullanmaya devam edebileceksiniz.",
    "view_on_blockchain_explorer": "Blockchain gezgini üzerinde görüntüle",
    "biz_sn": "İşlem Numarası",
    "type": "Tür",
    "create_time": "Oluşturma Zamanı",
    "logout_confirm": "Çıkış yapmak istediğinize emin misiniz?",
    "wallet": "Cüzdan",
    "continue_with_google": "Google ile Devam Et",
    "insufficient_balance_deposit_guide": "Yetersiz bakiye. Varlıkları yatırın yoksa işlemleriniz reddedilecek ve bir ücret talep edilebilir.",
    "to": "İçin",
    "bill_will_be_sent_to": "Fatura bildirimi gönderilecektir",
    "bill_statement": "Fatura Bildirimi",
    "export_bill": "Fatura Bildirimi Dışa Aktar",
    "this_month": "Bu Ay",
    "last_month": "Geçen Ay",
    "last_3_month": "Son 3 Ay",
    "this_year": "Bu Yıl",
    "last_year": "Geçen Yıl",
    "customize": "Özelleştir",
    "bill_export_success": "Fatura bildirimi e-posta adresinize gönderilmiştir, lütfen kontrol edin",
    "bill_empty": "Faturanız boş",
    "channel": "Kanal",
    "merchant_country": "Satıcı Ülkesi",
    "status": "Durum",
    "withdraw_detail": "Çekim Detayları",
    "new_key": "Yeni",
    "deposit": "Yatır",
    "withdraw": "Çek",
    "single_limit": "Tek Limit",
    "all": "TÜM",
    "minimum": "Minimum",
    "available": "Mevcut",
    "received_amount": "Alınan Miktar",
    "withdrawl": "Çek",
    "network_fee": "Ağ Ücreti",
    "register": "Kaydol",
    "register_login": "Kaydol/Giriş Yap",
    "login": "Giriş Yap",
    "email_Phone": "E-posta/Telefon Numarası",
    "email": "E-posta",
    "mobile": "Mobil",
    "next": "İleri",
    "or_continue_with": "Ya da devam et",
    "forgot_pw": "Şifrenizi mi unuttunuz?",
    "welcome_to_redotpay": "Sonic Pay'e Hoş Geldiniz",
    "verify_code": "Doğrulama Kodu",
    "get_code": "Kodu Al",
    "by_creating_an_account": "Bir hesap oluşturarak bizimle kabul edersiniz",
    "privacy_policy": "politikası",
    "terms_conditions": "Şartlar ve Koşullar",
    "and": "ve",
    "modify_pin": "PIN Değiştir",
    "pin_subtitle": "Güvenlik PIN'i hızlı doğrulama sağlar, kart numaralarını ve CVV bilgilerini görüntülemeyi kolaylaştırır.",
    "password_set_first_login": "Şifreyi ayarlamak için ilk giriş",
    "next_step": "Sonraki Adım",
    "confirm": "Onayla",
    "username": "Kullanıcı Adı",
    "password": "Şifre",
    "send_code": "Kodu Gönder",
    "send_code_to": "Kod gönderilecektir",
    "switch_option": "Doğrulama Seçeneğini Değiştir",
    "mobile_verification": "Mobil Doğrulama",
    "email_verification": "E-posta Doğrulama",
    "choose_verify_method": "Doğrulama Seçeneğini Değiştir",
    "verify_pin": "Güvenlik PIN'i",
    "google_authenticator_verification": "Google Authenticator",
    "security": "Güvenlik",
    "bound": "Bağlı",
    "unbound": "Bağlı Değil",
    "set": "Ayarla",
    "unset": "Kaldır",
    "update_pw": "Şifre Değiştir",
    "delete_account": "Hesabı İptal Et",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "Google Authenticator, çekimlerinizi ve hesabınızı korur.",
    "download_install": "İndir",
    "download_install_prompt": "Öncelikle Kimlik Doğrulayıcı uygulamasını (Google Authenticator) indirip yüklemeniz gerekiyor.",
    "backup_key": "Yedek anahtar",
    "save_backup_key": "Bu Yedek Anahtarı güvenli bir yerde saklayın",
    "google_authenticator_code": "Google Authenticator Kodu",
    "email_subtitle": "E-posta doğrulaması, çekimlerinizi ve hesabınızı korur.",
    "change_email": "E-posta Değiştir",
    "email_update": "E-posta Güncellemesi",
    "code": "Kod",
    "mobile_subtitle": "Mobil doğrulama, çekimlerinizi ve hesabınızı korur.",
    "change_mobile": "Mobil Değiştir",
    "mobile_update": "Mobil Güncellemesi",
    "mobile_bind": "Mobil Telefonu Bağla",
    "email_bind": "E-postayı Bağla",
    "old_password": "Eski Şifre",
    "new_password": "Yeni Şifre",
    "new_password_confirm": "Yeni Şifreyi Onayla",
    "language": "Dil",
    "appearance": "Görünüm",
    "logout": "Çıkış Yap",
    "log_out_toast": "Çıkış yaptınız",
    "set_pin": "Güvenlik PIN'i",
    "account_deletion_prompt_1": "Bu hesap asla geri alınamaz",
    "account_deletion_prompt_2": "Bu hesap tarafından oluşturulan tüm alt kullanıcılar / diğer hesaplar silinecek ve geri alınamaz.",
    "account_deletion_prompt_3": "Bu hesapla ilişkili tüm API anahtarları silinecektir.",
    "account_deletion_prompt_4": "Bu hesabın tüm mevcut yetkilendirilmiş ve bekleyen para çekimleri iptal edilecektir.",
    "account_deletion_prompt_5": "Bu hesabın tüm işlem işlevleri devre dışı bırakılacaktır.",
    "account_deletion_prompt_6": "Bu hesaptan çekilmeyen varlıklar, gönüllü olarak terkedilmiş varlıklar olarak kabul edilecektir.",
    "account_deletion_prompt_7": "Bir hesap silme başvurusu yaptığınızda, 15 günlük bir çekim süresi tanınır. Silme talebinden sonraki 15 gün içinde tekrar giriş yaparsanız, silme talebiniz iptal edilecek ve hesabınızı normal şekilde kullanmaya devam edebileceksiniz.",
    "kyc_status_0": "Gönderilmedi",
    "kyc_status_1": "Doğrulanıyor...",
    "kyc_status_2": "Onaylandı",
    "kyc_status_3": "Denetim Başarısız",
    "kyc_status_4": "Yeniden Gönderildi",
    "kyc_status_5": "Üst Düzeye Gönder",
    "personal_info_review": "Kişisel Bilgi İncelemesi",
    "additional_info_request": "Ek bilgi talebi",
    "verifying": "Doğrulanıyor...",
    "form_submitted_will_review_asap_new": "Başvurunuz manuel inceleme için gönderilmiştir. Bu süreç genellikle 3-5 gün sürer, ancak bazen daha uzun sürebilir. Lütfen sabırlı olun.",
    "get_verified": "Kimlik Doğrulama",
    "kyc_verified": "Kullanıcı Kimliği Doğrulandı",
    "approved": "Onaylandı",
    "not_able_to_submit_identity": "Kapsamlı inceleme sürecimizin bir parçası olarak, Müşterinizi Tanıyın (KYC) ve Kara Para Aklamayı Önleme (AML) tarama prosedürlerini tamamlamak için sizden ek bilgi talep ediyoruz.",
    "aml_review_failed": "Başvurunuza devam etmek için lütfen aşağıdaki düğmeye tıklayarak Kendini Beyan formuna erişin ve doldurun.",
    "aml_declaration_prompt": "Lütfen, talep edilen formun önümüzdeki 14 gün içinde sağlanmaması durumunda başvurunuzun reddedileceğini unutmayın.",
    "verify_your_identity": "Kimliğinizi Doğrulayın",
    "get_identity_verified": "Kart satın almak ve kullanmak için kimliğinizi doğrulayın",
    "country_region": "Ülke/Bölge",
    "given_name": "Ad",
    "surname": "Soyad",
    "date_of_birth": "Doğum Tarihi",
    "document_type": "Belge Türü",
    "document_number": "Belge Numarası",
    "given_name_intl": "Ad (ULUSLARARASI)",
    "surname_intl": "Soyad (ULUSLARARASI)",
    "click_to_add_signature": "İmza eklemek için tıklayın",
    "rewrite": "Yeniden Yaz",
    "submit": "Gönder",
    "save": "Kaydet",
    "accounts_are_not_available": "Hesaplar mevcut değil",
    "abandon_assets": "{{amount}} {{currency}} varlıklarını terk et",
    "account_deletion_successful": "Hesap silme başarılı",
    "passwords_do_not_match": "Şifreler eşleşmiyor",
    "password_reset_success": "Şifre sıfırlama başarılı",
    "password_confirm": "Şifre Onayla",
    "is_refund": "İade",
    "total_debt": "Toplam Borç",
    "your_account_is_in_arrears": "Hesabınız gecikme içindedir. Lütfen bakiyeyi kapatmak için yeterli miktarda para yatırın. Borç ödendikten sonra, hesabınız/kartınız bakiyeniz ≥10 USD olduğunda geri yüklenecektir.",
    "repayment": "Ödeme",
    "debit_record": "Borç Kaydı",
    "no_data": "Boş Veri",
    "payment": "Ödeme",
    "transaction_details": "İşlem Detayları",
    "transaction_date": "İşlem Tarihi",
    "transaction_id": "İşlem Kimliği",
    "view_linked_order": "Bağlantılı Siparişi Görüntüle",
    "rights_interests": "Haklar & Menfaatler",
    "transaction_limit": "İşlem Limiti",
    "deposit_withdraw": "Yatırma & Çekme",
    "card_purchased_number": "Satın alınabilir kart sayısı",
    "on_review_your_applicant": "Başvurunuz inceleniyor",
    "form_en_only": "Form sadece İngilizce doldurulabilir",
    "available_to_spend": "Harcamak için mevcut",
    "get_a_card": "Sonic kartı alın ve dünya çapında 44M+ Visa destekli satıcıda kullanın.",
    "virtual_card": "Sanal Kart",
    "physical_card": "Fiziksel Kart",
    "apply_card": "Kart Başvur",
    "enjoy_seamless_spending": "Harcamak",
    "spend_and_withdraw": "Harca & ATM çekimi",
    "card_labeling": "Kart Etiketleme",
    "card_tag": "Kart Etiketi",
    "edit_billing_address": "Fatura Adresi",
    "government_issued_id": "Devlet Tarafından Verilen Kimlik",
    "facial_recognition": "Yüz Tanıma",
    "address": "Adres",
    "personnel_information_details": "Kişisel Bilgi Detayları",
    "nation_list": "Ülke Listesi",
    "choose_channel": "Doğrulama Modu",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsAPP",
    "card_application_order": "Kart Başvuru Sırası",
    "promo_code_optional": "Promosyon Kodu (İsteğe Bağlı)",
    "promo_code": "Promosyon Kodu",
    "billing_address": "Fatura Adresi",
    "shipping_address": "Gönderim Adresi",
    "shipping_to": "Gönderilecek",
    "card_purchase_fee": "Kart Satın Alma Ücreti",
    "card_holder_name": "Kart Sahibi Adı",
    "city": "Şehir",
    "province_state": "İl/Eyalet",
    "postal_code": "Posta Kodu/ZIP",
    "address_line1": "Adres",
    "address_line2": "Adres Satırı 2",
    "please_fill_in_the_information_in_english": "Form sadece İngilizce doldurulabilir",
    "first_name": "Ad",
    "last_name": "Soyad",
    "country_code": "Ülke Kodu",
    "card_application_list": "Kart Başvuru Listesi",
    "buy_virtual_card": "Sanal Kart Satın Al",
    "buy_physical_card": "Fiziksel Kart Satın Al",
    "withdraw_list": "Çekim Listesi",
    "no_more_data": "Daha Fazla Veri Yok",
    "select_a_network": "Bir ağ seçin",
    "please_select_network": "Lütfen bir ağ seçin",
    "select_a_network_ensure": "Yatırmak için seçtiğiniz ağın çekim ağıyla eşleştiğinden emin olun, aksi takdirde varlıklar kaybolabilir.",
    "network": "Ağ",
    "card_management": "Kart Yönetimi",
    "freeze": "Dondur",
    "unfreeze": "Çöz",
    "freeze_card_des": "Tek tuşla kart kilitleme işlevi etkinleştirildiğinde, bu kartı kullanamazsınız, ancak diğer kartları etkilemez. Tek tuşla kart kilitleme işlevini iptal etmek istiyorsanız, buradan tekrar etkinleştirebilirsiniz.",
    "freezing_trades": "Bir kartı dondurmak, başarısız bir sipariş oluşturur ve işlem başarısızlığına veya reddedilen işlemler için ek ücrete neden olabilir.",
    "unfreeze_your_card_desc": "Tek tuşla kart kilitleme işlevi devre dışı bırakıldığında, bu kartı tekrar kullanabilirsiniz ve diğer kartları etkilemez. Kartı dondurmak isterseniz, buradan tekrar yapabilirsiniz.",
    "card_tag_set_success": "Kart etiketi başarıyla ayarlandı",
    "bill": "Fatura",
    "setting": "Ayarlar",
    "limit": "Limit",
    "assets_list": "Varlık Listesi",
    "empty_data": "Boş Veri",
    "deposit_list": "Yatırım Listesi",
    "date": "Tarih",
    "merchant_city": "Satıcı Şehri",
    "card_number": "Kart Numarası",
    "card_type": "Kart Türü",
    "mcc": "MCC",
    "declined_reason": "Reddedilme Nedeni",
    "card_authorization_payment": "Kart Yetkilendirme Ödemesi",
    "declined_transaction_fee": "Reddedilen İşlem Ücreti",
    "verified": "Doğrulandı",
    "notifications": "Bildirimler",
    "need_to_add_bill_address": "Fatura adresi eklemelisiniz",
    "need_to_add_shipping_address": "Gönderim adresi boş olamaz",
    "success": "Başarı",
    "welcome_redotpay": "Sonic Pay'e Hoş Geldiniz!",
    "reset_pw_alert": "Şifre değiştirildikten sonra, çekim ve iç transfer devre dışı bırakılacak ve kart işlemleri, güvenlik nedenleriyle önümüzdeki 24 saat içinde her işlem için 1000 $ ile sınırlı olacaktır.",
    "no_more_records": "Daha Fazla Kayıt Yok",
    "add": "Ekle",
    "address_label": "Adres Etiketi",
    "add_address": "Adres Ekle",
    "this_field_is_required": "Bu alan gereklidir",
    "ID_CARD": "Kimlik Kartı",
    "PASSPORT": "Pasaport",
    "DRIVERS": "Sürücü Belgesi",
    "RESIDENCE_PERMIT": "İkamet İzni",
    "amount": "Miktar",
    "withdraw_status_waiting": "Bekliyor",
    "withdraw_status_pending": "Beklemede",
    "withdraw_status_success": "Başarı",
    "withdraw_status_fail": "Başarısız",
    "withdraw_status_canceled": "İptal Edildi",
    "withdraw_status_declined": "Reddedildi",
    "withdraw_status_complete": "Tamamlandı",
    "order_id": "Sipariş ID",
    "click_or_scroll_to_load_more": "Daha fazla yüklemek için tıklayın veya kaydırın",
    "minimum_deposit_amount": "Asgari Yatırım Miktarı",
    "deposit_arrival_confirmations": "Yatırım varışı: {{confirmations}} onay",
    "confirmations": "{{confirmations}} Onay",
    "deposit_network": "Yatırım Ağı",
    "minimum_deposit": "Asgari Yatırım",
    "deposit_arrival": "Yatırım Varışı",
    "current_address_supports_depositing": "Mevcut adres sadece {{varietyCode}} için yatırımı destekler, diğer varlıklar kaybolacaktır.",
    "copy_successful": "Kopyalama Başarılı",
    "update_password_successful": "Şifre Güncellemesi Başarılı",
    "update_successful": "Güncelleme Başarılı",
    "successful": "Başarılı",
    "signature_required": "İmza Gerekli",
    "deposit_successful": "Yatırım Başarılı",
    "sign_out": "Çıkış Yap",
    "cancel_withdraw_order_success": "Çekim Siparişi İptali Başarılı",
    "delete_successful": "Silme Başarılı",
    "unfreeze_card_successful": "Kart Çözme Başarılı",
    "card_nickname_set_successful": "Kart Takma Adı Başarıyla Ayarlandı",
    "trans_limit_adjusted_success": "İşlem Limiti Başarıyla Ayarlandı",
    "set_card_pin_success": "Kart PIN'i Başarıyla Ayarlandı",
    "withdraw_apply_commit_please_wait": "Çekim başvurusu gönderildi, lütfen bekleyin",
    "unfreeze_success": "Çözme Başarılı",
    "freeze_success": "Dondurma Başarılı",
    "withdraw_duration_tip": "Çekim başvuruları bir iş günü içinde işlenecektir.",
    "you_will_withdraw": "Çekim yapacaksınız",
    "withdraw_info": "Çekim Bilgisi",
    "please_confirm_same_network": "Yatırmak için seçtiğiniz ağın Yatırım ağıyla eşleştiğinden emin olun, aksi takdirde varlıklar kaybolabilir.",
    "cancel_withdraw_order_confirm": "Çekimi iptal etmek istediğinizden emin misiniz?",
    "valid_thru": "geçerlidir",
    "last_7_days": "Son 7 Gün",
    "last_30_days": "Son 30 Gün",
    "today": "Bugün",
    "all_done": "Hepsi Tamam",
    "view_details": "Detayları Görüntüle",
    "withdraw_success": "Çekim Başarılı",
    "pay": "Öde",
    "fee": "ücret",
    "discount": "İndirim",
    "price": "Fiyat",
    "card_application_details": "Kart Başvuru Detayları",
    "card_pin": "Kart PIN'i",
    "card_pin_format_helper": "Üç ardışık aynı sayı veya ardışık sayılar içeremez",
    "digit_variable": "{{count}} haneli",
    "address_book": "Adres Defteri",
    "unlimited": "Sınırsız",
    "single": "Tek",
    "update_card_pin": "Kart PIN'ini Güncelle",
    "set_card_pin": "Kart PIN'ini Ayarla",
    "report_lost": "Kaybolduğunu Bildir",
    "report_lost_card": "Kaybolan kartı bildir",
    "card_lost_report_alert": "Kaybolduğunu bildirdikten sonra, kart devre dışı bırakılacak ve durumu değiştiremeyeceksiniz. Kartı tekrar kullanmak veya yeni bir kart başvurusu yapmak istiyorsanız, lütfen müşteri hizmetleri ekibiyle iletişime geçin.",
    "pending": "Beklemede",
    "frozen": "Dondurulmuş",
    "phone_number": "Telefon Numarası",
    "search": "Ara",
    "reset": "Sıfırla",
    "total_amount": "Toplam Miktar",
    "actual_amount": "Gerçek Miktar",
    "already_have_an_account": "Zaten Bir Hesabınız Var mı?",
    "create_account": "Bir Sonic Pay Hesabı Oluştur",
    "total_balance": "Toplam Bakiye",
    "cards_balance_available_promp": "Kredi limiti cüzdan varlıklarına göre anlık olarak hesaplanır",
    "got_it": "Anlaşıldı",
    "delete_this_address": "Bu adresi silmek istediğinizden emin misiniz?",
    "currency": "Para Birimi",
    "merchant_name": "Tüccar Adı",
    "request_time": "Talep Zamanı",
    "is_transaction_allowed": "Bu işlem izinli mi?",
    "approve": "Onayla",
    "decline": "Reddet",
    "card_in_production": "Kart üretimde",
    "redotpay_card_sent": "Redotpay kartı gönderildi",
    "redotpay_card_activated": "Redotpay kartı etkinleştirildi",
    "activate_card": "Kartı etkinleştir",
    "paste": "Yapıştır",
    "fees_included": "Dahil Ücretler",
    "fx_fee": "Döviz Ücreti",
    "small_auth_fee": "Küçük İşlem Ücreti",
    "atm_fee": "ATM Ücreti",
    "received": "Alındı",
    "incremental": "Artan",
    "bill_address_save_success": "Fatura adresi başarılı bir şekilde kaydedi",
    "no_more_trans_record": "Daha fazla işlem kaydı yok",
    "withdraw_amount_larger_than_available": "Kullanılabilir maksimum bakiyeden fazla",
    "withdraw_lower_than_min": "Asgari çekim miktarından düşük",
    "card_is_deleted": "Kart silinmiş",
    "something_error": "Bir şeyler ters gitti",
    "home": "Ana Sayfa",
    "select_country": "Ülke seç",
    "billing_list": "Fatura Listesi",
    "coupon_code": "รหัสส่วนลด",
    "password_rule1": "8 ila 32 karakter arasında",
    "password_rule2": "En az 1 İngilizce büyük harf",
    "password_rule3": "En az 1 İngilizce küçük harf",
    "password_rule4": "En az 1 sayı",
    "set_pw": "Parola ayarla",
    "payment_currency_settings": "Ödeme Para Birimi Ayarları",
    "customize_payment_currency": "Ödeme Para Birimini Özelleştir",
    "disable_non_local_tip": "Yerel olmayan para birimi işlemlerini devre dışı bırakmak, kart dolandırıcılığı riskini etkili bir şekilde azaltabilir",
    "charging_rules": "Ücretlendirme Kuralları",
    "reissue_card": "Kartı Yeniden Çıkar",
    "update_cvv": "CVV Güncelle",
    "update_cvv_desc": "Aynı kart numarası, yeni CVV ve yeni son kullanma tarihi.",
    "reissue_fee": "Yeniden Çıkarma Ücreti",
    "fx_fee_desc": "Döviz ücreti (FX Ücreti), varsayılan olmayan para birimi işlem ücreti %1,2'yi içerir (varsa).",
    "atm_fee_desc": "Her ATM çekiminde ek %2 ücret alınacaktır.",
    "remit_fee_desc": "Visa kredi veya banka kartı kullanım ücreti.",
    "risk_safety_tips": "Güvenlik İpuçları",
    "risk_safety": "Güvenlik nedeniyle, ilgili işlemlere devam etmeden önce uygulamada yüz tanıma doğrulamasını tamamlayın.",
    "go_to_app_verify": "Doğrulama için Uygulamaya Git",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "Hemen RedotPay'e Git",
    "close": "Kapat",
    "card_cancellation": "Kart İptali",
    "delete_card": "Kartı Sil",
    "delete_card_desc": "Kart silindikten sonra kullanılamaz hale gelir ve bu işlem geri alınamaz.",
    "deleting_fee": "Silme Ücreti",
    "currency_tips": "Para Birimi İpuçları",
    "at_least_one_currency": "Lütfen en az bir ödeme yapılabilir para birimi bırakın.",
    "all_select_currency": "Tüm para birimlerini zaten işlem için destekliyorsunuz.",
    "small_auth_transaction_fee_stas": "Küçük İşlem Ücreti Detayları",
    "small_transactions_this_month": "Bu Ayki Küçük İşlemler",
    "small_autn_trans_remain": "Bu ay ücret alınmayan küçük işlem sayısı",
    "rules": "Kurallar",
    "failed_rules": "Başarısız işlemler, hatalı işlem kaydı sayısını artırır ve sınırı aşarsanız ek ücretler alınır. Lütfen işlemi düzenli yapın.",
    "rule_item": "Madde",
    "free_count": "Ücretsiz Sayı",
    "fees": "Ücretler",
    "declined_trans_remain": "Bu ay ücret alınmayan reddedilen işlem sayısı",
    "declined_transaction_fee_stats": "Reddedilen İşlem Ücret İstatistikleri",
    "declined_rules": "Başarısız işlemler, hatalı işlem kaydı sayısını artırır ve sınırı aşarsanız ek ücretler alınır. Lütfen işlemi düzenli yapın.",
    "declined_transactions_this_month": "Bu ayki reddedilen işlem sayısı",
    "card_trans_detail_status_refund": "İade İşleniyor",
    "card_trans_status_reversal": "Ters Çevirme",
    "card_trans_status_fully_refund": "Tamamlandı, Tam İade Yapıldı",
    "card_trans_status_partial_refund": "Tamamlandı, Kısmi İade Yapıldı",
    "card_trans_status_void": "Geçersiz",
    "first_time_free": "İlk Kullanımda Ücretsiz",
    "FxFee": "Döviz Ücreti",
    "AtmFee": "ATM Ücreti",
    "RemitFee": "Havale Ücreti",
    "MccFee": "MCC Ücreti",
    "mcc_fee_desc": "Bazı tüccarlar, işlem tutarının %1,5'i kadar ek ücret alacaktır. Ücret 0,5 USD'nin altında ise, minimum 0,5 USD alınacaktır.",
    "please_deposit": "Lütfen Para Yatırın",
    "special_mcc_fee": "Özel MCC Ücreti",
    "bank_verifying": "Bu iade banka tarafından inceleniyor…",
    "estimate_time": "Tahmini ulaşma süresi: 2-30 gün",
    "delete_out": "Çıkış Yap",
    "card_is_loss": "Kart kayıp olarak bildirildi",
    "incremental_desc": "Yetkilendirilen tutar yetersizse ek ücretler alınacak ve ilgili tutar, ödeme sırasında eklenecektir.",
    "card_trans_status_fully_refund1": "Tamamlandı",
    "card_trans_status_fully_refund2": "Tamamen İade Edildi",
    "card_trans_status_partial_refund1": "Tamamlandı",
    "card_trans_status_partial_refund2": "Kısmen İade Edildi",
    "review_takes_time": "İnceleme 2 dakikadan 24 saate kadar sürer.",
    "custom_date_null": "Lütfen özel bir tarih seçin",
    "custom_date_error": "Lütfen doğru sorgu zamanını ayarlayın",
    "small_trade_fee": "Küçük işlem ücreti",
    "user_risk_exception": "Kullanıcı Durum Hatası",
    "request_exception": "İstek Hatası",
    "mobile_is_not_empty": "Lütfen geçerli bir cep telefonu numarası girin",
    "code_is_not_empty": "Lütfen geçerli bir doğrulama kodu girin",
    "browser_paste_error": "Tarayıcı kısıtlamaları, lütfen manuel olarak girin"
  }
};